


























































































































































import axios from '../plugins/axios';
import {Component, Vue, Prop, Mixins, Watch} from 'vue-property-decorator';
import {Product as ProductType, File, Image} from '../types/CheckoutServerData';
import {Mixin} from "@/mixins";
import MeasurementView from "measurement-view-generator/dist/classes/MeasurementView";
import {InputData} from "measurement-view-generator/dist/types/types";
import store from '@/store';
import Lightbox from "@/components/Lightbox.vue";

enum SpecialWishStatus {
    Saved = 'saved',
    Editing = 'editing',
    Empty = 'empty'
}

@Component({
    components: {Lightbox},
    mixins: [
        Mixin
    ],
    name: "Product",
})
export default class Product extends Mixins(Mixin) {
    @Prop()
    product!: ProductType;

    @Prop()
    isPersonalized!: boolean;

    $refs!: {
        image: HTMLDivElement,
        text: HTMLDivElement,
        measurementViewCanvas: HTMLCanvasElement,
        preview: HTMLDivElement,
    };

    store = store();

    lang = lang;

    SpecialWishStatus = SpecialWishStatus;
    specialWishStatus = this.product.specialWish ? SpecialWishStatus.Saved : SpecialWishStatus.Empty;
    image: string | null = null;
    selectedFileImageIndex: number | null = null;
    selectedGeneratedImageIndex: number | null = null;

    @Watch('product.specialWish')
    onSpecialWishChange(val: string) {
        if (val && this.specialWishStatus === SpecialWishStatus.Empty) {
            this.specialWishStatus = SpecialWishStatus.Saved;
        }
    }

    async updateImage(width: number = 240, height: number = 240) {
        if (typeof this.product.image !== 'undefined' && this.product.image !== null) {
            this.image = this.product.image;
            return;
        }

        if (this.product.configurationJson && window.factories && this.store.serverData.confCoreConfig) {
            const config = window.factories.createConfig(this.store.serverData.confCoreConfig);
            const store = await window.factories.createStore(config);
            const manager = window.factories.createManager(store);
            const measurementRenderer = window.factories.createRenderer(
                store,
                'modularMeasurement',
            );
            await manager.parse(this.product.configurationJson);
            measurementRenderer.setCanvasSize(width, height);
            this.image = await measurementRenderer.getImage('cart_view');
            return;
        } else if (this.product.configurationJson && this.$refs.measurementViewCanvas && this.product.generateImage) {
            let data: InputData = this.product.configurationJson!;
            const setting = {
                canvas: this.$refs.measurementViewCanvas,
                modelView: true,
                showLabels: false,
            };
            let measurementView = new MeasurementView(setting, data);
            measurementView.renderObject();
            this.image = this.$refs.measurementViewCanvas.toDataURL();
            return;
        }

        this.image = null;
    }

    get windowLang(): string {
        return window.lang;
    }

    get productGroup(): string {
        return this.product.type === "modular" ? "modular" : "configurable";
    }

    get productGroupClass(): string {
        return this.product.type === "modular" ? "modular" : "conf2";
    }

    get imageFiles(): Array<File> {
        return this.product.files ? this.product.files.filter(file => file.mime.substr(0, 5) === 'image') : [];
    }

    private get generatedImageFiles(): Array<Image> {
        if (!this.product.images) {
            return [];
        }

        const images: Image[] = [];
        for (const imagesKey in this.product.images) {
            images.push({
                name: imagesKey,
                url: this.product.images[imagesKey].src
            });
        }
        return images;
    }

    private get isLowerBox(): boolean {
        return (this.image === null && !this.product.color) || !this.isDescriptionBox;
    }

    private get isDescriptionBox(): boolean {
        return this.product.type !== 'wood_samples' && this.product.classification !== 'service';
    }

    async edit() {
        try {
            this.store.loading = true;
            let formData = new FormData();
            formData.append('id', this.product.id.toString());
            formData.append('lang', lang);
            let res = await axios.post('/api/cart/edititem', formData);
            window.location.href = res.data;
        } catch (e) {
            console.error(e);
            this.store.loading = false;
        }
    }

    async copy() {
        try {
            this.store.loading = true;
            let formData = new FormData();
            formData.append('id', this.product.id.toString());
            formData.append('lang', lang);
            await axios.post('/api/cart/copyitem', formData);
            await this.store.syncServer();
        } catch (e) {
            this.store.loading = false;
            console.error(e);
        }
    }

    async unset() {
        try {
            this.store.loading = true;
            let formData = new FormData();
            formData.append('id', this.product.id.toString());
            formData.append('lang', lang);
            const {data} = await axios.post('/api/cart/unsetitem', formData);
            this.store.setCartData(data.data);
        } catch (e) {
            this.store.loading = false;
            console.error(e);
        }
    }

    setSize() {
        let style = getComputedStyle(this.$refs.preview)
        let canvasHeight = this.$refs.preview.clientHeight
            - (style.paddingTop ? parseInt(style.paddingTop) : 0)
            - (style.paddingBottom ? parseInt(style.paddingBottom) : 0);
        let canvasWidth = this.$refs.preview.clientWidth
            - (style.paddingLeft ? parseInt(style.paddingLeft) : 0)
            - (style.paddingRight ? parseInt(style.paddingRight) : 0);

        // set maße view canvas size
        if (this.$refs.measurementViewCanvas) {
            this.$refs.measurementViewCanvas.height = canvasHeight * 2;
            this.$refs.measurementViewCanvas.width = canvasWidth * 2;
        }

        this.updateImage(this.$refs.measurementViewCanvas.width, this.$refs.measurementViewCanvas.height);
    }

    onFileClick(file: File, event: PointerEvent) {
        if (file.mime.substr(0, 5) !== 'image') {
            return;
        }

        event.preventDefault();
        this.selectedFileImageIndex = this.imageFiles.indexOf(file);
    }

    async mounted() {
        await this.$nextTick();
        this.setSize();
        window.addEventListener('resize', this.setSize);

        // only in Chrome, because Safari will destroy the image quality with this setting
        if (this.$refs.image && navigator.appVersion.indexOf("Chrome/") != -1) {
            this.$refs.image.style.setProperty('image-rendering', '-webkit-optimize-contrast');
        }
    }

    updated() {
        this.setSize();
    }

    destroyed() {
        window.removeEventListener('resize', this.setSize);
    }

    saveSpecialWish() {
        this.specialWishStatus = this.product.specialWish ? SpecialWishStatus.Saved : SpecialWishStatus.Empty
        if (this.store.loading === false) {
          this.store.syncServer();
        }
    }

    removeSpecialWish() {
        this.specialWishStatus = SpecialWishStatus.Empty;
        this.$set(this.product, 'specialWish', '');
        this.$set(this.store.serverData.productsSpecialWish, this.product.id, '');
        this.store.syncServer();
    }
}
